<script>
export let registrations;


import PaymentThumb from 'components/views/my/team/thumbs/Payment.svelte';
import ErrorPanelBlock from 'components/elements/ErrorPanelBlock.svelte';


import tippy from 'sveltejs-tippy';


const postdated_amount_props = {
	content: '...',
	placement: 'bottom',
	arrow: false,
};


const postdated_dates_props = {
	content: '...',
	placement: 'bottom',
	arrow: false,
};


</script>


<style>

#payments-table {

}

</style>



<div class="panel" id="payments-table">

	<div class="panel-heading">

		<div class="columns is-variable is-mobile is-2 is-vcentered">

			<div class="column is-3-desktop is-4-touch">
				<span>Player Name</span>
			</div>

			<div class="column is-4-desktop is-4-touch">
				<span use:tippy={postdated_amount_props}>
					Postdated Amount
					<i class="far fa-info-circle"></i>
				</span>
			</div>

			<!-- <div class="column is-5-desktop is-4-touch">
				<span use:tippy={postdated_dates_props}>
					Postdated Date(s)
					<i class="far fa-info-circle"></i>
				</span>
			</div> -->

		</div>

	</div>

	{#each registrations as registration}
		<PaymentThumb {registration} />
	{/each}

	{#if registrations.length === 0}
		<ErrorPanelBlock msg={'No registrations yet.'} />
	{/if}

</div>


<!-- ... -->